import settings from 'Cloud/settings';
import { IS_BIZ_USER } from 'reactApp/appHelpers/configHelpers';
import { activitiesFeature, isFeatureAlbumFavorites } from 'reactApp/appHelpers/featuresHelpers';
import {
    IS_ALL_DOC_SHARED_SORT_ENABLED,
    IS_ALL_DOC_SORT_ENABLED,
} from 'reactApp/appHelpers/featuresHelpers/features/alldocumentsSortEnabled';
import { INCOMING_PUBLIC_DELETION } from 'reactApp/appHelpers/featuresHelpers/features/incomingPublicDeletion';
import { type IEnabledActions, EStorageType } from 'reactApp/modules/storage/storage.types';

const disabledAll: IEnabledActions = {
    copy: false,
    move: false,
    remove: false,
    rename: false,
    history: false,
    favorites: false,
    publish: false,
    share: false,
    openParentFolder: false,
    download: false,
    add: false,
    view: false,
    sort: false,
    facesFilter: false,
    selectAll: false,
    mount: false,
    sendViaMail: false,
    publishAlbum: false,
    createAlbum: false,
    // tempexp_17340-start
    changeDesign: false,
    changeDesignMore: false,
    // tempexp_17340-end
    complain: false,
    // tempexp_18662-next-line
    publicInfo: false,
    createVigboGallery: false,
    goToVigbo: false,
    watchVigboGallery: false,
    setupVigboGallery: false,
    addToGallery: false,
    printVigbo: false,

    makeFamilyFolder: false,
    makeFamilyFolderCommon: false,
};

export const INLINE_INTEGRATION_STORAGE_FULL = `${EStorageType.inlineIntegration}_full`;
export const STORAGE_CONFIG: Record<string, Record<string, boolean>> = {
    [EStorageType.home]: {
        ...disabledAll,
        publish: true,
        copy: true,
        favorites: true,
        move: true,
        rename: true,
        share: true,
        remove: true,
        history: true,
        download: true,
        add: true,
        sort: true,
        view: true,
        selectAll: true,
        createFolder: true,
    },
    [EStorageType.search]: {
        ...disabledAll,
        openParentFolder: true,
        publish: true,
        copy: true,
        favorites: true,
        move: true,
        rename: true,
        share: true,
        remove: true,
        history: true,
        download: true,
        view: true,
        selectAll: true,
        add: true,
    },
    [EStorageType.sharedIncoming]: {
        ...disabledAll,
        share: true,
        remove: true,
        download: true,
        selectAll: true,
        mount: true,
        add: true,
        sort: IS_BIZ_USER,
        history: activitiesFeature.sharedIncoming,
    },
    [EStorageType.sharedLinks]: {
        ...disabledAll,
        publish: true,
        share: true,
        download: true,
        sort: true,
        view: true,
        selectAll: true,
        add: true,
        history: activitiesFeature.sharedLinks,
    },
    [EStorageType.sharedAutodelete]: {
        ...disabledAll,
        publish: true,
        share: true,
        view: true,
        favorites: false, // не приходит флаг из апи v2
        openParentFolder: false, // путь до папки не приходит в нужном регистре
        remove: true,
        rename: true,
        move: true,
        selectAll: true,
        add: true,
        history: activitiesFeature.sharedAutodelete,
    },
    [EStorageType.public]: {
        ...disabledAll,
        remove: true,
        view: true,
        sort: true,
        download: true,
        clone: true,
        add: true,
        shareLink: true,
        selectAll: true,
        facesFilter: true,
        history: activitiesFeature.public,
        complain: true,
    },
    [EStorageType.favorites]: {
        ...disabledAll,
        openParentFolder: true,
        publish: true,
        copy: true,
        favorites: true,
        move: true,
        share: true,
        remove: true,
        view: true,
        selectAll: true,
        add: true,
        sort: IS_BIZ_USER,
        download: true,
        history: activitiesFeature.favorites,
    },
    [EStorageType.feed]: {
        ...disabledAll,
        openParentFolder: true,
        publish: true,
        copy: true,
        move: true,
        share: true,
        remove: true,
        view: true,
        download: true,
        selectAll: true,
        add: true,
        history: activitiesFeature.feed,
    },
    [EStorageType.gallery]: {
        ...disabledAll,
        openParentFolder: true,
        publish: true,
        copy: true,
        favorites: true,
        move: true,
        rename: true,
        share: true,
        remove: true,
        history: true,
        download: true,
        view: true,
        selectAll: true,
        add: true,
        sort: IS_BIZ_USER,
    },
    [EStorageType.start]: {
        ...disabledAll,
        publish: true,
        copy: true,
        favorites: true,
        move: true,
        rename: false,
        share: true,
        remove: true,
        history: true,
        add: true,
        sort: IS_BIZ_USER,
    },
    [EStorageType.trashbin]: {
        ...disabledAll,
        restore: true,
        restoreAll: true,
        clear: true,
        selectAll: true,
        add: true,
        sort: IS_BIZ_USER,
        history: activitiesFeature.trashbin,
    },
    [EStorageType.attaches]: {
        ...disabledAll,
        download: true,
        view: true,
        sendViaMail: true,
        clone: true,
        publish: true,
        add: true,
        sort: IS_BIZ_USER,
        history: activitiesFeature.attaches,
    },
    [EStorageType.viewerAttaches]: {
        ...disabledAll,
        download: true,
        view: true,
        sendViaMail: true,
        clone: true,
        publish: true,
    },
    [EStorageType.stock]: {
        ...disabledAll,
        view: true,
        sort: true,
        download: true,
        clone: true,
        selectAll: true,
    },
    [EStorageType.documents]: {
        ...disabledAll,
        openParentFolder: true,
        remove: true,
        move: true,
        copy: true,
        publish: true,
        favorites: true,
        selectAll: true,
        download: true,
        add: true,
        history: activitiesFeature.documents,
    },
    [EStorageType.templates]: {
        ...disabledAll,
        selectAll: false,
        add: true,
    },
    [EStorageType.quotaCleaner]: {
        ...disabledAll,
        selectAll: true,
        back: true,
        view: true,
        download: true,
        quotaCleanerDelete: true,
    },
    [EStorageType.albums]: {
        ...disabledAll,
        selectAll: true,
        remove: true,
        favorites: isFeatureAlbumFavorites,
        publish: true,
        view: true,
        download: true,
        rename: true,
        add: true,
    },
    [EStorageType.vigbo]: {
        ...disabledAll,
        selectAll: true,
        remove: true,
        publish: false,
        view: true,
        download: true,
        rename: true,
        add: true,
        watchVigboGallery: true,
        setupVigboGallery: true,
    },
    [EStorageType.recommend]: {
        ...disabledAll,
        add: true,
    },
    [EStorageType.alldocuments]: {
        ...disabledAll,
        openParentFolder: true,
        publish: true,
        copy: true,
        move: true,
        share: true,
        remove: true,
        view: true,
        download: true,
        selectAll: true,
        createFolder: false,
        add: true,
        history: true,
        rename: true,
        sort: IS_ALL_DOC_SORT_ENABLED,
    },
    [EStorageType.pdfEdit]: {
        ...disabledAll,
        publish: true,
        favorites: true,
        download: true,
    },
    [EStorageType.integration]: {
        ...disabledAll,
        add: true,
        publish: true,
    },
    [EStorageType.inlineIntegration]: {
        ...disabledAll,
        remove: true,
        add: true,
    },
    [INLINE_INTEGRATION_STORAGE_FULL]: {
        ...disabledAll,
        publish: true,
        copy: true,
        move: true,
        rename: true,
        download: true,
        remove: true,
        add: true,
        view: true,
        selectAll: true,
        createFolder: true,
    },
    [EStorageType.sharingAttach]: {
        ...disabledAll,
    },
    [EStorageType.incomingPublic]: {
        ...disabledAll,
        view: true,
        download: true,
        selectAll: true,
        createFolder: false,
        add: true,
        remove: INCOMING_PUBLIC_DELETION,
        sort: IS_ALL_DOC_SHARED_SORT_ENABLED,
    },
    [EStorageType.familyFolders]: {
        ...disabledAll,
        add: true,
    },
    [EStorageType.familyAlbums]: {
        ...disabledAll,
        add: true,
    },
    [EStorageType.familyLanding]: {
        ...disabledAll,
        selectAll: true,
        back: true,
        view: true,
        download: true,
        quotaCleanerDelete: true,
    },
};

export const getStorageConfig = (storage: EStorageType): IEnabledActions => {
    const config = STORAGE_CONFIG[storage] || {};

    const oldSettings = settings?.storages?.[storage]?.settings ?? {};

    return { ...oldSettings, ...config };
};
